import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DomainDisabledIcon from "@mui/icons-material/DomainDisabled";
import { getAuth } from "firebase/auth";
import { useTenant } from "hooks/settings";

export const TenantNotFound = () => {
  const { t } = useTranslation();
  const auth = getAuth();
  const tenant = useTenant();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        px: 3,
      }}
    >
      <DomainDisabledIcon
        sx={{
          fontSize: 120,
          color: "text.secondary",
          mb: 3,
        }}
      />

      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: "4rem", sm: "6rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 2,
          lineHeight: 1,
        }}
      >
        404
      </Typography>

      <Typography
        variant="h4"
        sx={{
          fontWeight: 500,
          color: "text.primary",
          mb: 2,
        }}
      >
        {t("tenantNotFound")}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          mb: 1,
          maxWidth: 500,
        }}
      >
        {t("tenantNotFoundDescription")}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 1,
        }}
      >
        {t("tenant")}: <strong>{tenant}</strong>
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 4,
        }}
      >
        {t("contactSupport")}{" "}
        <a href={`mailto:${t("scrapChefSupportEmailAddress")}`}>
          {t("scrapChefSupportEmailAddress")}
        </a>
      </Typography>

      <Stack direction="row" spacing={2}>
        <Button
          onClick={() => {
            window.history.back();
          }}
          variant="outlined"
          size="large"
          sx={{
            px: 4,
            borderRadius: 2,
            textTransform: "none",
            fontSize: "1.1rem",
            fontWeight: 600,
          }}
        >
          {t("back")}
        </Button>
        <Button
          onClick={() => void auth.signOut()}
          variant="contained"
          size="large"
          sx={{
            px: 4,
            borderRadius: 2,
            textTransform: "none",
            fontSize: "1.1rem",
            fontWeight: 600,
          }}
        >
          {t("signOut")}
        </Button>
      </Stack>
    </Box>
  );
};
